import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import AvgButton from '../ComControl/AvgButton'
import MusicItem from '../ComControl/MusicItem'
import { FileReader, FileWriter } from '@/platform'
class GameTitleData {
    /**
     * 是否显示Logo1
     */
    public IsLogo: boolean = false

    /**
     * Logo的图片
     */
    public LogoPic: FileName = new FileName()

    /**
     * 标题画面图片
     */
    public TitlePic: FileName = new FileName()

    /**
     * 标题画面音乐
     */
    public TitleBGM: MusicItem = new MusicItem()

    /**
     * 是否绘制标题文字
     */
    public IsDrawText: boolean = false

    /**
     * 标题画面按钮集合 project_bin_no
     */
    public Buttons: AvgButton[] = []

    /**
     * 按钮索引集
     */
    public ButtonsEx: AvgButtonIndex[] = []

    /**
     * 是否使用自有坐标 project_bin_no
     */
    public IsFree: boolean = false

    /**
     * project_bin_no
     */
    public BIndex: number[] = []

    constructor(btn?: AvgButton[]) {
        if (btn !== undefined) {
            this.IsLogo = true
            this.LogoPic = new FileName({ type: FileName.DEF_TYPE, name: '' })
            this.TitlePic = new FileName({ type: FileName.DEF_TYPE, name: 'Title.png' })
            this.TitleBGM = new MusicItem({name: new FileName({ type: FileName.DEF_TYPE, name: '' }), volume: 80})
            this.Buttons = btn
            this.IsDrawText = true
            this.BIndex = [2, 3, 4, 5, 6, 7]
            this.ButtonsEx = new Array<AvgButtonIndex>(this.BIndex.length)
            for (let i: number = 0; i < this.BIndex.length; i++) {
                if (i == 2 || i == 3) {
                    this.ButtonsEx[i] = new AvgButtonIndex()
                } else {
                    this.ButtonsEx[i] = new AvgButtonIndex(
                        this.BIndex[i],
                        this.Buttons[i]?.X,
                        this.Buttons[i]?.Y
                    )
                }
            }
        }
    }

    /** cg_v3_data：IsLogo → LogoPic → TitlePic → TitleBGM → IsDrawText → Buttons → ButtonsEx → IsFree → BIndex */
    readBin(reader: FileReader) {
        this.IsLogo = reader.readBool()
        this.LogoPic = new FileName(reader)
        this.TitlePic = new FileName(reader)
        this.TitleBGM = new MusicItem()
        this.TitleBGM.readBin(reader)
        this.IsDrawText = reader.readBool()

        this.Buttons = []
        const btnLen = reader.readInt()
        for (let i = 0; i < btnLen; i++) {
            const b = new AvgButton()
            b.readBin(reader)
            this.Buttons.push(b)
        }

        this.ButtonsEx = []
        const exLen = reader.readInt()
        for (let i = 0; i < exLen; i++) {
            const avgIndexBtn = new AvgButtonIndex()
            avgIndexBtn.readBin(reader)
            this.ButtonsEx.push(avgIndexBtn)
        }

        this.IsFree = reader.readBool()

        this.BIndex = []
        const biLen = reader.readInt()
        for (let i = 0; i < biLen; i++) {
            this.BIndex.push(reader.readInt())
        }
    }

    writeBin(writer: FileWriter): void {
        writer.writeBool(this.IsLogo)
        this.LogoPic.writeBin(writer)
        this.TitlePic.writeBin(writer)
        this.TitleBGM.writeBin(writer)
        writer.writeBool(this.IsDrawText)

        writer.writeInt(this.Buttons.length)
        for (let i = 0; i < this.Buttons.length; i++) {
            this.Buttons[i]!.writeBin(writer)
        }

        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            this.ButtonsEx[i]!.writeBin(writer)
        }

        writer.writeBool(this.IsFree)

        writer.writeInt(this.BIndex.length)
        for (let i = 0; i < this.BIndex.length; i++) {
            writer.writeInt(this.BIndex[i]!)
        }
    }

    readVersionedOui(reader: FileReader) {
        this.IsLogo = reader.readInt() == 1 ? true : false
        this.LogoPic.readVersionedOui(reader.readObj(reader.readInt()))
        this.TitlePic.readVersionedOui(reader.readObj(reader.readInt()))
        this.IsDrawText = reader.readInt() == 1 ? true : false
        this.TitleBGM.readVersionedOui(reader.readObj(reader.readInt()))

        let avgIndexLen = reader.readInt()
        for (let i = 0; i < avgIndexLen; i++) {
            let avgIndexBtn = new AvgButtonIndex()
            avgIndexBtn.readVersionedOui(reader.readObj(reader.readInt()))
            this.ButtonsEx.push(avgIndexBtn)
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()

        writer.writeInt(this.IsLogo ? 1 : 0)
        this.LogoPic.writeVersionedOui(writer)
        this.TitlePic.writeVersionedOui(writer)
        writer.writeInt(this.IsDrawText ? 1 : 0)
        this.TitleBGM.writeVersionedOui(writer)

        writer.writeInt(this.ButtonsEx.length)
        for (let i = 0; i < this.ButtonsEx.length; i++) {
            const avgBtnIndex = this.ButtonsEx[i]
            avgBtnIndex.writeVersionedOui(writer)
        }

        writer.writerLength()
    }

    writeGameBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}
export default GameTitleData
